import CloseIcon from '@mui/icons-material/Close';
import { Alert, Grid2 as Grid, IconButton, Typography, useTheme } from '@mui/material';
import React, { useMemo } from 'react';

import { IOneLinkErrors } from '../../../contexts/OneLinkSummaryProvider';

interface IProps {
  onClose: () => void;
  errors?: IOneLinkErrors;
}

export const AlertErrorBanner: React.FC<IProps> = ({ onClose, errors }) => {
  const theme = useTheme();

  const errorMessages = useMemo(
    () =>
      Object.values(errors ?? {})
        .flatMap((fields: IOneLinkErrors[keyof IOneLinkErrors]) => Object.values(fields))
        // need to filter out the empty strings from the backend
        .filter((message) => message.length > 0),
    [errors],
  );

  return (
    <Grid size={12} sx={{ mb: 2 }}>
      <Alert
        severity="error"
        action={
          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <Typography component="span">
          Activation cannot be completed at this time. Please update the following:{' '}
          <Typography component="span" sx={{ fontWeight: theme.sass.fontWeightBold }}>
            {errorMessages.join(', ')}
          </Typography>
        </Typography>
      </Alert>
    </Grid>
  );
};
